module.exports = __webpack_public_path__ + "img/tallcypress.14655bb5.webp";